/**
 * Collector Profile Preview — Concept Data
 * ─────────────────────────────────────────
 * A single, shared data object that drives the `<CollectorProfilePreview />`
 * mockup component. Update *this file only* to change the concept preview
 * shown on the Home and Register pages.
 *
 * All values here are a **fixed concept preview** (Gil Maakaroun's approved
 * example) and are NOT connected to backend data. The component consuming
 * this file is purely a visual mockup that helps prospective collectors
 * understand what the future Collector Network profile will look like.
 *
 * Field reference:
 *   name              — display name shown in the profile header
 *   avatarSettingKey  — key on `useSiteSettings()` whose URL supplies the
 *                       avatar image (reuses Gil's approved portrait)
 *   verified          — shows the "Verified Collector" badge
 *   level             — collector level (numeric)
 *   stats             — { certificates, albums, completed, inProgress }
 *   totals            — { missingStickers, duplicates }
 *   albums            — array of { name, percent, status } where status is
 *                       "completed" or "in-progress"
 *   badges            — array of short badge labels
 *   tradeRecommendations — array of natural-language trade preview lines
 *
 * If `avatarSettingKey` cannot be resolved at render time, the component
 * falls back gracefully to an icon placeholder.
 */

export const GIL_COLLECTOR_PROFILE = {
  name: "GIL MAAKAROUN",
  avatarSettingKey: "hero_image_url",
  verified: true,
  level: 3,

  stats: {
    certificates: 1,
    albums: 4,
    completed: 2,
    inProgress: 2,
  },

  totals: {
    missingStickers: 86,
    duplicates: 659,
  },

  albums: [
    { name: "World Cup Album 2014",             percent: 100, status: "completed"   },
    { name: "USA/CAN/MEX 2026 World Cup Album", percent: 100, status: "completed"   },
    { name: "World Cup Album 2018",             percent: 58,  status: "in-progress" },
    { name: "World Cup Album 2022",             percent: 72,  status: "in-progress" },
  ],

  badges: [
    "2014 Completion",
    "2026 Completion",
    "Multi-Tournament",
    "Level 3",
  ],

  tradeRecommendations: [
    "Mark has 18 stickers you need for your 2018 World Cup album.",
    "John has 43 stickers you need for your 2022 World Cup album.",
    "You have 23 duplicates another collector needs.",
  ],
};
